import axios from 'axios';
import {ChargeRequestLogTypes} from "../../types/transaction/transaction.types";
import {saveChargeRequestLog} from "../../api/transaction/chargeApi";
import {defaultAlert} from "../../utils/alert";

const REACT_APP_CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
const PAYMENT_URL = process.env.REACT_APP_PG_PAYMENT_API_URL;
const PAYMENT_KEY = process.env.REACT_APP_PG_AUTH_KEY;
const TMN_ID = process.env.REACT_APP_PG_AUTH_TMN_ID;

//인증
const getPaymentToken = async () => {
    const response = await axios.post(
        `${PAYMENT_URL}/api/auth/login`,
        { tmnId: TMN_ID },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${PAYMENT_KEY}`
            }
        }
    );
    return response.data.token;
};

export const requestPayment = async (
    amt: number,
    chargeFee: number,
    goodsName: string,
    ordNm: string,
    email: string,
    isMobile: boolean
) => {
    try {
        const token = await getPaymentToken();
        const tid = `autoCare_charge_${new Date().getTime()}`;

        sessionStorage.setItem("tid", tid);
        sessionStorage.setItem("payToken", token);

        const chargeRequestLog: ChargeRequestLogTypes = {
            chargeAmount: Number(amt),
            chargeFee: Number(chargeFee),
            tid: tid,
            payToken: token,
            paymentData: null
        };

        const saveRes = await saveChargeRequestLog(chargeRequestLog);

        if (saveRes.data.code !== "00") {
            defaultAlert("충전 요청 실패");
            return;
        }

        const  url = isMobile ? `${PAYMENT_URL}/api/bankpay/mobile/request` : `${PAYMENT_URL}/api/bankpay/request`
        const response = await axios.post(
            url,
            {
                tid: tid,
                tmnId: TMN_ID,
                amt: amt,
                goodsName: goodsName,
                ordNm: ordNm,
                email: email,
                productType: "00",
                payMethod: "BPAY",
                cashReceipt: 0,
                isMandatoryIssuer: false,
                returnUrl: isMobile ? `${REACT_APP_CLIENT_URL}/charge/callback` : '',
                redirectUrl: isMobile ? `${REACT_APP_CLIENT_URL}/charge/callback` : ''
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        );

        return response;

    } catch (err) {
        console.error('결제 요청 실패:', err);
        throw err;
    }
};


//결제 상태 조회
export const getPaymentStatus = async (tid: string) => {
    if (!tid) {
        throw new Error('tid is required');
    }

    try {
        const token = await getPaymentToken();
        const response = await axios.get(
            `${PAYMENT_URL}/api/payment/status/${tid}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response;
    } catch (err) {
        console.error('결제 상태 조회 실패:', err);
        throw err;
    }
};


// 결제 취소 요청
export const requestPaymentCancel = async (tid: string, cancelReason: string = "사용자 취소") => {
    if (!tid) {
        throw new Error('tid is required');
    }

    try {
        const token = await getPaymentToken();

        const response = await axios.post(
            `${PAYMENT_URL}/api/payment/cancelRequest`,
            {
                tid: tid,
                tmnId: TMN_ID,
                cancelReason: cancelReason
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        );

        return response;

    } catch (err) {
        console.error('결제 취소 실패:', err);
        throw err;
    }
};

